// Static: which questions are worth suggesting is a product decision.
const GENERAL_PROMPTS: readonly string[] = [
    "Which bills are overdue?",
    "What needs my approval today?",
    "What changed on my jobs this week?",
];

const JOB_PROMPTS: readonly string[] = [
    "How is this job going?",
    "What is left to schedule on this job?",
    "Which selections are still undecided?",
];

export interface ITryAskingContext {
    /** The entity kind of the record the user currently has open, if any. */
    openRecordEntity: string | null;
}

function isJob(context: ITryAskingContext): boolean {
    return context.openRecordEntity === "job" || context.openRecordEntity === "jobsite";
}

/** Prompts to offer, narrowed by what the user is looking at: "this job" has
 * no referent off a job page. */
export function getTryAskingPrompts(context: ITryAskingContext): readonly string[] {
    return isJob(context) ? JOB_PROMPTS : GENERAL_PROMPTS;
}

/**
 * Whether the prompts on offer say "this", so Ask has to be told which record
 * that is. Ask is another page and cannot work it out from its own location.
 */
export function tryAskingRefersToOpenRecord(context: ITryAskingContext): boolean {
    return isJob(context);
}
